<template>
  <ChatBtn></ChatBtn>
</template>

<script setup>
import ChatBtn from '@/views/ChatBtn.vue'

let vh= window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh',`${vh}px`);

</script>
